<div class="sidebar-wrapper d-flex flex-column h-100">
  <aside class="client-sidebar entity-sidebar d-flex flex-column h-100 bg-white border-0 border-opacity-50 px-3 px-lg-4 pt-3 pb-3 overflow-hidden">
    <div class="sidebar-content d-flex flex-column flex-grow-1 min-h-0">
      <div class="sidebar-brand d-flex align-items-center px-0 pb-3 mb-3">
        <img :src="logo_src" alt="Complyon" class="sidebar-brand-logo img-fluid">
      </div>

      <nav class="ai-sidebar-scroll flex-grow-1 overflow-auto d-flex flex-column gap-3 pe-2 min-h-0">
        <section v-for="section in sidebar_sections" :key="section.id" class="sidebar-section">
          <div class="sidebar-role-block px-0 pb-2">
            <div class="sidebar-role-meta fw-semibold">{{ section.label }}</div>
          </div>

          <ul class="list-unstyled d-flex flex-column gap-1 mb-0">
            <li v-for="item in section.items" :key="item.id">
              <button
                type="button"
                class="nav-link d-flex align-items-center justify-content-between w-100 text-start px-1 py-2 bg-transparent border-0 text-body-secondary"
                :class="{ active: is_active_menu(item) }"
                :aria-current="is_active_menu(item) ? 'page' : null"
                @click="set_active_menu(item.id)"
              >
                <span class="d-flex align-items-center gap-3 min-w-0">
                  <i :class="['bi', item.icon, 'text-secondary fs-6 flex-shrink-0']"></i>
                  <span class="flex-grow-1 text-truncate text-s">{{ item.label }}</span>
                </span>

                <span v-if="item.badge" :class="['badge rounded-pill fw-semibold flex-shrink-0', item.badge_class]">
                  {{ item.badge }}
                </span>

                <span v-else-if="item.count" :class="['badge rounded-pill fw-semibold flex-shrink-0', item.count_class]">
                  {{ item.count }}
                </span>
              </button>
            </li>
          </ul>
        </section>
      </nav>

      <div class="mt-3 pt-3 border-top">
        <div class="sidebar-user d-flex align-items-center gap-3 min-w-0">
          <span class="avatar-circle flex-shrink-0">
            {{ current_user_initials }}
          </span>

          <span class="d-flex flex-column min-w-0">
            <span class="text-truncate fw-bold sidebar-user-name">{{ current_user_name }}</span>
            <span class="text-truncate small text-secondary">{{ current_user_role }}</span>
          </span>
            <span class="btn btn-light btn-sm rounded-circle d-inline-flex align-items-center justify-content-center flex-shrink-0 px-0">
            <i class="bi bi-gear"></i>
            </span>
        </div>

        <!-- <button
          type="button"
          class="sidebar-signout btn btn-link text-decoration-none d-inline-flex align-items-center gap-3 px-0 mt-3"
          @click="sign_out"
        >
          <i class="bi bi-box-arrow-right"></i>
          <span>Sign Out</span>
        </button> -->
      </div>
    </div>
  </aside>
</div>
